import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// es
import esPasskeys from './locales/es/passkeys.json';
import esAuthenticatorApp from './locales/es/authenticatorApp.json';
import esLogin from './locales/es/login.json';
import esTwoFactorOnboarding from './locales/es/twoFactorOnboarding.json';
import esPrivacyNoticeOnboarding from './locales/es/privacyNoticeOnboarding.json';

// en
import enPasskeys from './locales/en/passkeys.json';
import enAuthenticatorApp from './locales/en/authenticatorApp.json';
import enLogin from './locales/en/login.json';
import enTwoFactorOnboarding from './locales/en/twoFactorOnboarding.json';
import enPrivacyNoticeOnboarding from './locales/en/privacyNoticeOnboarding.json';

const resources = {
  en: {
    passkeys: enPasskeys,
    authenticatorApp: enAuthenticatorApp,
    login: enLogin,
    twoFactorOnboarding: enTwoFactorOnboarding,
    privacyNoticeOnboarding: enPrivacyNoticeOnboarding,
  },
  es: {
    passkeys: esPasskeys,
    authenticatorApp: esAuthenticatorApp,
    login: esLogin,
    twoFactorOnboarding: esTwoFactorOnboarding,
    privacyNoticeOnboarding: esPrivacyNoticeOnboarding,
  },
};

const lang = sessionStorage.getItem('lang');
i18n.use(initReactI18next).init({
  resources,
  lng: lang,
  fallbackLng: 'es',
  interpolation: {
    escapeValue: false,
  },
  detection: {
    order: ['sessionStorage', 'navigator'],
    caches: ['sessionStorage'],
  },
});

export default i18n;
